module.exports = __webpack_public_path__ + "img/dg_accs.06c65ccc.png";